module.exports = __webpack_public_path__ + "static/img/promptPay2.2cb0cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment/promptPay2.png
// module id = Y8aU
// module chunks = 150